<template>
  <div>
    <div
      class="sidenav"
      :class="[
        $router.currentRoute.name == 'billing/checkout'
          ? 'sidenav-disabled'
          : $loading
          ? 'sidenav-hover-disabled'
          : null,
      ]"
    >
      <ul>
        <li class="py-2 pb-4">
          <a href="javascript:void(0)">
            <img
              src="../assets/images/zg-logo.svg"
              alt="Zwing"
              width="23"
              class="logo-icon"
              v-if="state.system.isOffline == false"
            />
            <img
              src="../assets/images/Icon_ZWING_offline.svg"
              width="23"
              class="logo-icon"
              v-if="state.system.isOffline == true"
            />
            <img
              src="../assets/logoWhite.svg"
              alt="Zwing"
              width="95"
              class="logo-full"
              v-if="state.system.isOffline == false"
            />
            <img
              src="../assets/Logo_ZWING offline.svg"
              alt="Zwing"
              width="95"
              class="logo-full"
              v-if="state.system.isOffline"
            />
            <span
              v-if="state.system.isOffline"
              class="pt-2"
              style="float: right"
              >Offline</span
            >
            <span v-else class="text-success pt-2" style="float: right"
              >Online</span
            >
          </a>
        </li>

        <li class="dashboard-icon">
          <router-link
            v-bind:to="routeLink"
            class="back-disable"
            active-class="active"
          >
            <img
              src="../assets/images/go-back-left-arrow.svg"
              title="Home"
              class="icon text-white"
              alt
            />
            Back
          </router-link>
        </li>
        <li class="dashboard-icon" title="POS">
          <router-link
            v-bind:to="billingRoute"
            :class="parentActiveNav('billing')"
            id="nav-pos"
          >
            <img
              src="../assets/images/billing.svg"
              title="Home"
              class="icon"
              alt
            />
            POS
          </router-link>
        </li>
        <li
          :class="
            checkTransactionType != 'order' ? parentActiveNav('invoices') : null
          "
          id="opacity"
        >
          <router-link
            v-bind:to="'../invoices-history'"
            active-class="active"
            title="Invoices"
            id="nav-invoices"
          >
            <img
              src="../assets/images/invoices.svg"
              alt="Invoices"
              class="icon"
            />
            Invoices
          </router-link>
        </li>
        <li
          title="Gift Vouchers"
          :class="parentActiveNav('gift-vouchers')"
          @click="setBillingMode"
        >
          <router-link
            :class="state.system.isOffline ? 'disable' : null"
            :event="state.system.isOffline ? '' : 'click'"
            :to="'../gift-vouchers'"
            id="gift-vouchers"
          >
            <img
              src="../assets/images/zw-gift-card.svg"
              alt="gift voucherst"
              class="icon"
              :class="state.system.isOffline ? 'iconopacity' : null"
            />
            Gift Vouchers
          </router-link>
        </li>
        <li
          title="Cash Management"
          :class="parentActiveNav('cash-management')"
          v-if="checkCashMgmt"
        >
          <router-link
            :class="state.system.isOffline ? 'cash-management' : null"
            :event="state.system.isOffline ? '' : 'click'"
            v-bind:to="'../cash-management'"
            id="cash-management"
          >
            <img
              src="../assets/images/cash-drawer.svg"
              alt="cash management"
              class="icon"
              :class="state.system.isOffline ? 'iconopacity' : null"
            />
            Cash Management
          </router-link>
        </li>
        <li :class="parentActiveNav('inventory')">
          <a
            href="javascript:void(0)"
            title="Inventory"
            :class="state.system.isOffline ? 'disable' : null"
          >
            <img
              src="../assets/images/inventory.svg"
              class="icon"
              :class="state.system.isOffline ? 'iconopacity' : null"
            />
            Inventory
          </a>
          <ul v-show="state.system.isOffline == false">
            <li>
              <router-link
                :class="state.system.isOffline ? 'cash-management' : null"
                :event="state.system.isOffline ? '' : 'click'"
                v-bind:to="'../stock-audit'"
                id="nav-stock-audit"
                >Stock Audit</router-link
              >
            </li>
            <li v-if="false">
              <router-link
                v-bind:to="'../advice-list'"
                active-class="active"
                id="nav-grn-against-advice"
                >GRN against advice</router-link
              >
            </li>
            <li v-if="false">
              <router-link
                v-bind:to="'../adhoc-grn'"
                active-class="active"
                id="nav-ad-hoc-grn"
                >Ad-hoc GRN</router-link
              >
            </li>
            <li v-if="false">
              <router-link
                v-bind:to="'../grn-list'"
                active-class="active"
                id="nav-grn-list"
                >GRN List</router-link
              >
            </li>
          </ul>
        </li>
        <li :class="parentActiveNav('customer-list')">
          <router-link
            v-bind:to="'../customer-list'"
            :class="state.system.isOffline ? 'disable' : null"
            :event="state.system.isOffline ? null : 'click'"
            title="Customers"
            id="nav-customers"
          >
            <img
              src="../assets/images/profile.svg"
              alt="customers"
              :class="state.system.isOffline ? 'iconopacity icon' : 'icon'"
              v-bind:to="'../customer-list'"
              :event="state.system.isOffline ? '' : 'click'"
            />
            Customers
          </router-link>
          <!-- <ul>
            <li>
              <router-link
                v-bind:to="'../customer-list'"
                :class="state.system.isOffline ? 'disable' : ''"
                :event="state.system.isOffline ? '' : 'click'"
                >Customers List</router-link
              >
            </li>
          </ul> -->
        </li>
        <li
          :class="
            checkTransactionType == 'order'
              ? 'router-link-active active'
              : parentActiveNav('order-management')
          "
          v-if="$store.getters.isOMSEnabled"
        >
          <router-link
            v-bind:to="'../order-management'"
            :class="state.system.isOffline ? 'disable' : null"
            :event="state.system.isOffline ? null : 'click'"
            title="Order Management"
            id="nav-customers"
          >
            <img
              src="../assets/images/zw-orders.svg"
              alt="Order Management"
              :class="state.system.isOffline ? 'iconopacity icon' : 'icon'"
              v-bind:to="'../customer-list'"
              :event="state.system.isOffline ? '' : 'click'"
            />
            Order Management
          </router-link>
          <!-- <a href="javascript:void(0)" title="Order Management">
            <img
              src="../assets/images/zw-orders.svg"
              alt="customers"
              :class="state.system.isOffline ? 'iconopacity icon' : 'icon'"
            />
            Order Management
          </a> -->
          <!-- <ul>
            <li>
              <router-link
                v-bind:to="'../order-management'"
                :class="state.system.isOffline ? 'disable' : ''"
                :event="state.system.isOffline ? '' : 'click'"
                >Order List</router-link
              >
            </li>
          </ul> -->
        </li>
        <!-- <li><a href="#" title="Profile"><img src="../assets/images/profile.svg" alt="Profile"></a></li> -->
        <li :class="parentActiveNav('settings')" title="Settings">
          <router-link v-bind:to="'../settings'">
            <img
              src="../assets/images/settings.svg"
              alt="settings"
              class="icon"
              id="nav-settings"
            />
            Settings
          </router-link>
        </li>
        <li>
          <a
            href="javascript:void(0)"
            title="Open Session"
            class="text-success"
            v-if="state.sessions.session.type == 'open'"
            @click="checkSessionStatus"
            id="nav-open-session"
          >
            <img
              src="../assets/images/start_session.svg"
              alt="Open session"
              class="icon"
            />
            Open Session
          </a>
          <a
            href="javascript:void(0)"
            title="Close Session"
            class="text-danger setting"
            v-if="state.sessions.session.type == 'close'"
            @click="checkSessionStatus"
            id="nav-close-session"
          >
            <img
              src="../assets/images/close_session.svg"
              alt="Close session"
              class="icon"
            />
            Close Session
          </a>
        </li>
        <li>
          <a
            v-bind:to="'../billing'"
            id="logout_btn_nav"
            @click="checkForLogout"
            class="logout"
          >
            <img
              src="../assets/images/Logout.svg"
              alt="Sales Person"
              class="icon"
              id="logout"
            />
            Logout
          </a>
        </li>
        <li v-if="false">
          <a href="javascript:void(0)" style="cursor: default; color: #fff">
            <font-awesome-icon
              v-if="!socketSync"
              class="icon text-success"
              :icon="['fas', 'sync']"
            />
            <font-awesome-icon
              v-if="socketSync"
              class="icon animate-sync-logo text-success"
              :icon="['fas', 'sync']"
            />Data Sync
          </a>
        </li>
        <!-- <li>
          <p
            style="border-radius:50%; width:13px; height:13px; display:inline-block; background:#28a745; margin-left:20px; margin-top:20px"
            v-if="online"
          >
            <span class="white-color float-left status-text">You're Online</span>
          </p>
          <p
            style="border-radius:50%; width:13px; height:13px; display:inline-block; background:red; margin-left:20px; margin-top:20px"
            v-if="offline"
          >
            <span class="white-color float-left status-text">You're Offline</span>
          </p>
        </li>-->
      </ul>
      <ul>
        <li class="store-detail py-3">
          <b-row>
            <b-col md="6" class="pt-1 left">
              <h6 class="m-0" v-text="state.system.settings.store.name" />

              <p class="mt-1" v-text="state.system.settings.store.location" />
            </b-col>
            <b-col md="4 text-center">
              <img
                src="../assets/images/DefIMG_StoreLogo.svg"
                alt
                height="63"
              />
            </b-col>
          </b-row>
        </li>
      </ul>

      <session-modal-box
        :open="session.openBox"
        @close-session="sessionBoxClose"
      />

      <!-- Force sessin modal box-->
      <b-modal
        ref="force-session-box"
        size="md"
        centered
        no-close-on-backdrop
        hide-footer
        hide-header
      >
        <p class="mb-4 fs-14 d-flex">
          <img src="../assets/images/alert.svg" class="mr-3" alt /> Session
          Active on other Terminal
        </p>
        <b-row>
          <b-col md="6">
            <label class="pl-0">Terminal</label>
            <p>mPOS | Pinetree P100</p>
          </b-col>
          <b-col md="6">
            <label class="pl-0">Session opened at</label>
            <p>{{ currencySymbol }} 2,500.00</p>
          </b-col>
          <b-col md="6">
            <label class="pl-0">Opening Balance</label>
            <p>22 Jul 2020, 14:00:42</p>
          </b-col>
          <b-col md="6">
            <label class="pl-0">Total Cash sale (18)</label>
            <p>{{ currencySymbol }} 48,500.00</p>
          </b-col>
          <b-col md="6">
            <label class="pl-0">Total Cash-in (2)</label>
            <p>{{ currencySymbol }} 2,500.00</p>
          </b-col>
          <b-col md="6">
            <label class="pl-0">Total Cash-out (0)</label>
            <p>{{ currencySymbol }} 0.00</p>
          </b-col>
          <b-col md="12" class="fs-12 mt-3">
            <p>
              You can only have one active session at a time. To open a new
              session on this terminal you must close any other active session
              on any terminal.
            </p>
            <p>Do you wish to force close the previous session?</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <footer class="mt-4">
              <b-row>
                <b-col md="6">
                  <b-button variant="primary" class="w-100">
                    <span v-if="$loading == false">Logout</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </b-button>
                </b-col>
                <b-col md="6">
                  <b-button variant="danger" class="w-100">
                    <span v-if="$loading == false">Force Close Session</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </b-button>
                </b-col>
              </b-row>
            </footer>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal id="log_out" size="sm" hide-footer hide-header centered>
        <p class="fs-14 d-flex title">
          <img src="../assets/images/icon_notif.svg" alt class="mr-2" />Logout
        </p>
        <p class="pt-2" v-text="logoutMsg"></p>
        <div class="pt-4">
          <b-button
            class="mr-1"
            @click="$bvModal.hide('log_out'), ($loading = false)"
            :disabled="$loading"
            >Cancel</b-button
          >
          <b-button
            variant="danger"
            class="ml-1"
            @click="logout"
            :disabled="$loading"
          >
            <span v-if="!$loading">Logout</span>
            <b-spinner small v-if="$loading" />
          </b-button>
        </div>
      </b-modal>

      <!-- Date validation popup-->
      <b-modal
        ref="date-validation"
        size="sm"
        hide-footer
        hide-header
        centered
        no-close-on-esc
        no-close-on-backdrop
      >
        <h5 class="modal-title">Incorrect Date/Time</h5>
        <div class="d-block text-center">
          <p class="mb-2 mt-3" v-text="incorrectTimeMsg"></p>
        </div>
        <div class="text-right">
          <b-button class="mt-3" variant="danger" @click="logout" id="logout"
            >Logout</b-button
          >
        </div>
      </b-modal>

      <!-- stop back modal -->
      <b-modal
        id="stop_back"
        size="sm"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        hide-header
        centered
      >
        <p class="fs-14 d-flex title">
          <img src="../assets/images/icon_notif.svg" alt class="mr-2" /> Return
          to Payment
        </p>
        <p class="pt-2" v-text="splitMsg"></p>
        <div class="d-flex pt-4">
          <b-button
            class="mr-1"
            @click="$bvModal.hide('stop_back')"
            block
            id="dismiss-split"
            :disabled="$loading"
            variant="outline-primary"
          >
            <!-- Return to Payment -->
            Dismiss
          </b-button>
          <b-button
            class="ml-1"
            block
            @click="cancelBill"
            variant="primary"
            id="cancel-bill-split"
            :disabled="$loading"
          >
            <span v-if="!$loading">Cancel Bill</span>
            <b-spinner small v-if="$loading" />
          </b-button>
        </div>
      </b-modal>
      <!-- stop back modal -->
    </div>

    <!-- offline message notification -->
    <div class="wide-alert text-center" v-if="offline">
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="danger"
        fade
        @dismiss-count-down="countDownChanged"
      >
        <span class="text-center" v-text="offlineMsg" />
      </b-alert>
    </div>

    <!-- online message notification -->
    <div class="wide-alert text-center" v-if="online">
      <b-alert
        :show="dismissCountDown"
        dismissible
        fade
        class="alert-success"
        @dismiss-count-down="countDownChanged"
      >
        <span class="text-center" v-text="onlineMsg" />
      </b-alert>
    </div>
    <message-box
      :open="error"
      @close-message="flushError"
      :message="errorMsg"
    />
    <session-force-close
      :open="openForceSessionModal"
      @close-force-modal="(openForceSessionModal = false), checkSession()"
    />
  </div>
</template>

<script>
import SessionModalBox from "../components/SessionModalBox";
import * as msg from "../message";
import MessageBox from "../components/MessageBox";
import { mapState } from "vuex";
import SessionForceClose from "./SessionForceClose";
export default {
  name: "navbar",
  components: {
    SessionModalBox,
    MessageBox,
    SessionForceClose,
  },
  data() {
    return {
      session: {
        type: "",
        openBox: false,
        forceSessionBox: true,
      },

      dismissSecs: 3,
      dismissCountDown: 0,
      logoutMsg: "",
      splitMsg: "",
      online: true,
      offline: false,
      isOnline: true,
      slownet: false,
      error: false,
      openForceSessionModal: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
        info: "",
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    checkCashMgmt() {
      let check = false;
      this.state.system.settings.vendor_app_menu.profile_tab_menu.map(
        (item) => {
          item.data.map((item) => {
            if (item.name == "cashmanagement" && item.status == 1) {
              check = true;
            }
          });
        }
      );
      return check;
    },
    currencySymbol() {
      let symbol = "";
      if (
        this.state.system.settings.vendor_login_details.hasOwnProperty(
          "currency"
        )
      ) {
        symbol = this.state.system.settings.vendor_login_details.currency
          .symbol;
      } else {
        symbol = "₹";
      }

      return symbol;
    },
    socketSync() {
      return this.state.system.socket_data_sync;
    },
    routeLink() {
      let route = "../billing";
      if (this.isGvSale) route = "/gift-vouchers";
      if (
        this.transTypeDeposit ||
        (this.state.billing.billing.order.data != "" &&
          this.state.billing.billing.order.data.trans_sub_type ==
            "Credit-Note") ||
        (this.state.billing.billing.order.data != "" &&
          this.state.billing.billing.order.data.trans_sub_type == "Refund-CN")
      )
        route =
          "/customer-list/" + this.state.billing.billing.customer.data.mobile;
      else if (this.state.billing.trans_sub_type == "order")
        route =
          "/order-summary/" + this.state.billing.billing.order.data.order_id;
      return route;
    },
    transTypeDeposit() {
      return this.$store.getters["billing/checkIfTransTypeDeposit"];
    },
    checkTransactionType() {
      return this.state.billing.trans_sub_type;
    },
    customerScreenTrxn() {
      let temp = false;
      if (
        (this.state.billing.billing.hasOwnProperty("pay_balance_deposit") &&
          this.state.billing.billing.pay_balance_deposit.trans_sub_type ==
            "Deposit-DN") ||
        (this.state.billing.billing.hasOwnProperty("pay_balance_deposit") &&
          this.state.billing.billing.pay_balance_deposit.trans_sub_type ==
            "Credit-Note") ||
        (this.state.billing.billing.order.data != "" &&
          this.state.billing.billing.hasOwnProperty("pay_balance_deposit") &&
          this.state.billing.billing.pay_balance_deposit.trans_sub_type ==
            "Refund-CN")
      )
        temp = true;
      return temp;
    },
    isGvSale() {
      return this.state.giftVoucher.isGvSale;
    },
    billingRoute() {
      let route = "../billing";
      if (
        this.$router.currentRoute.params.hasOwnProperty("order_from") &&
        this.$router.currentRoute.params.order_from == "success"
      )
        route = "../../billing";
      return route;
    },
  },
  watch: {
    notification() {
      setTimeout(() => {
        this.offline == true;
        // this.$store.commit("resetAlert");
      }, 3000);
      setTimeout(() => {
        this.online == true;
        // this.$store.commit("resetAlert");
      }, 3000);
    },
  },
  created() {
    this.logoutMsg = msg.LOGOUT_MESSAGE;
    this.splitMsg = msg.SPLIT_MESSAGE;
    this.offlineMsg = msg.OFFLINE_MESSAGE;
    this.onlineMsg = msg.ONLINE_MESSAGE;
    this.incorrectTimeMsg = msg.INCORRECT_TIME;
  },
  mounted() {
    // this.settlementData();
    this.netConnected();
    this.checkSession();
    // this.checkCurrentDate();

    // console.log(this.$router.currentRoute);
    // this.addActiveClass();
    // console.log(this.$router);
    // console.log(this.$parent.$options);
  },
  methods: {
    checkSessionStatus() {
      if (
        this.state.system.settings.settlement
          .closing_previous_session_compulsory.status == 1 &&
        this.state.system.settings.settlement.open_sesssion_compulsory.status ==
          1 &&
        !this.SessionForceClose
      ) {
        this.session.openBox = true;
      } else {
        this.error = true;
        this.errorMsg.text = msg.SESSION_MNGMT_DISABLED;
        this.errorMsg.btnText = "Close";
      }
    },
    checkForLogout() {
      if (
        this.state.system.isOffline == false &&
        this.state.system.settings.settlement
          .closing_previous_session_compulsory.status == 1 &&
        this.state.system.settings.settlement.open_sesssion_compulsory.status ==
          1 &&
        this.state.system.settings.settlement.opening_balance_status == 1
      ) {
        this.$loading = true;
        this.$store.dispatch("system/getLatestSettings").then(() => {
          this.$loading = false;
          if (
            this.state.system.settings.settlement
              .closing_previous_session_compulsory.status == 1 &&
            this.state.system.settings.settlement.opening_balance_status == 1
          ) {
            // this.session.openBox = true;
            this.error = true;
            this.errorMsg.text = msg.CLOSE_SESSION;
            this.errorMsg.info = "to close your active session now and logout.";
            this.errorMsg.btnText = "Close";
            this.errorMsg.type = "logout";
          }
        });
      } else {
        this.$bvModal.show("log_out");
      }
    },
    checkCurrentDate() {
      if (this.state.system.settings.hasOwnProperty("setting_date_time")) {
        let settingInvokeDate = this.state.system.settings.setting_date_time
          .date_time;
        let currentTime = this.$moment().format("DD-MM-YYYY hh:mm:ss");
        //  console.log(settingInvokeDate)
        //  console.log(currentTime)
        if (currentTime < settingInvokeDate) {
          this.$refs["date-validation"].show();
        }
      }
    },
    netConnected() {
      window.addEventListener("online", () => {
        this.online = true;
        this.offline = false;
        this.dismissCountDown = this.dismissSecs;
      });
      window.addEventListener("offline", () => {
        this.offline = true;
        this.online = false;
        this.dismissCountDown = this.dismissSecs;
      });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    logout() {
      this.$loading = true;
      this.$store
        .dispatch("sessions/logout")
        .then(() => {
          this.$router.push("/");
          this.$loading = false;
          // location.reload();
        })
        .catch(() => {
          let alertData = {
            message: msg.INTERNAL_SERVER_ERROR,
            type: "success",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
        });
    },
    settlementData() {
      if (this.openForceSessionModal) return;
      // var self = this;
      let data = this.$store.state.sessions.session;
      this.session.type = data.type;
      // console.log("[Nav Settlement Data] : " + JSON.stringify(data));
      if (data.required == 1) {
        this.session.openBox = true;
      }
    },
    sessionBoxClose(data) {
      this.session.openBox = data;
    },
    forceSessionBoxClose(data) {
      this.session.forceSessionBox = data;
    },
    addActiveClass() {
      if (
        document
          .querySelector(".sidenav .active")
          .parentElement.parentElement.closest("li")
      ) {
        document
          .querySelector(".sidenav .active")
          .parentElement.parentElement.closest("li")
          .classList.add("active");
      }

      /* document
        .querySelector(".sidenav .active")
        .parentElement.parentElement.parentElement.classList.add("active");
     document
        .querySelector(".router-link-exact-active")
        .parentElement.classList.add("active");*/
    },
    parentActiveNav(value) {
      let check = "";
      let currentRoute = this.$router.currentRoute;
      if (currentRoute.name.indexOf(value) != -1 && !this.customerScreenTrxn) {
        check = "router-link-active active";
      } else if (value == "customer-list" && this.customerScreenTrxn)
        check = "router-link-active active";
      return check;
    },
    // childActiveNav() {
    //   let check = "";
    //   let currentRoute = this.$router.currentRoute;
    //   return check;
    // },
    cancelBill() {
      // console.log(value);
      this.$loading = true;
      let productData = {
        barcode: "",
        url: "remove-product-from-cart",
        product_id: "",
        cart_id: "",
        all: "1",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let data = Object.assign(productData, this.customerData);
      this.$store
        .dispatch("billing/cancelBill", data)
        .then(() => {
          this.$loading = false;
          this.$router.push("/billing");
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    flushError(val) {
      if (val == "session") {
        this.error = false;
        this.session.openBox = true;
      } else this.error = val;
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
    checkSession() {
      if (
        !this.state.system.isOffline &&
        (this.state.system.settings.settlement.force_session_close.status ==
          1 ||
          this.state.system.settings.settlement.sessionExpire.status == 1)
      )
        this.openForceSessionModal = true;
      this.settlementData();
    },
    setBillingMode() {
      this.$store.commit("billing/setBillingMode", "normal");
    },
  },
};
</script>
<style lang="scss" scoped>
.sidenav:hover {
  width: 290px;
}
.cash-management {
  cursor: no-drop;
  &:hover {
    color: #818181;
    background: transparent;
  }
}
.disable {
  cursor: no-drop;
}
.disable:hover {
  background-color: #202020;
  color: #818181;
}
.sidenav.sidenav-hover-disabled:hover {
  width: 50px;
}
.sidenav.sidenav-disabled:hover {
  width: 50px;

  ul li ul {
    display: none;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .logo-full {
    display: none;
  }
  .logo-icon {
    transition: all 0.9s ease-in-out;
    display: block;
  }
  .store-detail {
    display: none;
  }
  ul li a {
    cursor: context-menu !important;
  }
  ul li {
    pointer-events: none;
    .logout {
      pointer-events: visible;
    }
    .back-disable {
      pointer-events: visible;
    }
  }

  a:hover {
    cursor: context-menu !important;
    background: transparent !important;
  }

  .logout:hover {
    background: #101010 !important;
    pointer-events: visible;
    cursor: pointer !important;
  }
  .back-disable:hover {
    background: #101010 !important;
    pointer-events: visible;
    cursor: pointer !important;
  }
}
.sidenav-disabled {
  ul li:nth-child(3) {
    display: none !important;
  }

  // ul li.dashboard-icon > a.active {
  //   background: transparent !important;
  // }
  // ul li.dashboard-icon > a.active:before {
  //   background: transparent !important;
  // }
}
.sidenav.sidenav-hover-disabled:hover {
  width: 50px;
  .logo-full {
    display: none;
  }
  .logo-icon {
    display: block;
  }
  .store-detail {
    display: none;
  }
  ul li {
    pointer-events: none;
  }
  cursor: wait;
}
.sidenav.sidenav-disabled {
  ul li:nth-child(2) {
    display: block !important;
  }
}
.sidenav ul li {
  ul li:nth-child(2) {
    display: block !important;
  }
}
.sidenav {
  ul li:nth-child(2) {
    display: none !important;
  }
}
.sidenav ul li {
  ul li:nth-child(2) {
    display: block !important;
  }
}
.sidenav:hover .store-detail {
  height: 95px;
  opacity: 1;
  transition: all 0.5s;
}

.sidenav .logo-icon,
.sidenav .logo-full {
  position: absolute;
  left: 13px;
  top: 10px;
}
.sidenav:hover .logo-icon {
  display: none;
}
.logo-full {
  display: none;
}
.sidenav:hover .logo-full {
  transition: all 0.9s ease-in-out;
  display: block;
  top: 0px;
}
.sidenav a {
  font-size: 0.875rem;
  padding: 15px 10px 15px 20px;
  span {
    margin-top: -10px;
    color: #fa5a5a;
  }
  .icon {
    margin-top: -3px;
    margin-right: 18px;
    width: 14px;
  }
}
.sidenav a {
  .iconopacity {
    opacity: 0.2;
    cursor: no-drop;
  }
}
.sidenav ul li:hover ul {
  display: block;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.sidenav ul + ul {
  position: absolute;
  bottom: 10px;
}
.sidenav ul li ul {
  display: none;
  position: relative;
  width: 100%;
  background: #101010;
  top: 0px;
  padding-left: 47px;
}
.sidenav ul li ul {
  li {
    padding: 8px 10px;
    text-align: left;
    position: relative;
    list-style: none;
    a {
      font-size: 12px;
      padding: 4px 0 !important;
      outline: 0;
      &:hover {
        color: #fff;
      }
    }
    .fa-circle-notch {
      margin-right: 10px;
      margin-top: -2px;
    }
  }
}
.offline-mode .sidenav ul li.active > a:before,
.offline-mode .sidenav ul li.dashboard-icon > a.active:before {
  background: #4fb0ad !important;
}
.sidenav {
  .setting {
    color: #fa5a5a !important;
    img {
      opacity: 1;
    }
  }
  .logout {
    color: #fa5a5a !important;
    img {
      opacity: 1;
    }

    &:hover {
      color: #cc3333 !important;
      cursor: pointer;
      opacity: 1;
    }
  }
  .setting:hover {
    color: #cc3333 !important;
    opacity: 1;
  }

  .bottom-icon {
    a {
      color: #fa5a5a !important;
    }
    a:hover {
      color: #cc3333 !important;
    }
  }
}
.sidenav ul li:first-child a:hover img {
  opacity: 1 !important;
}
.store-detail {
  background: #202020;
  transition: all 0.5s;
  opacity: 0;
  bottom: 0;
  position: relative;
  -webkit-transition: all 0.2s; /* For Safari 3.1 to 6.0 */
  .left {
    margin-left: 26px;
  }
}
.alert-success {
  color: #fff;
  background-color: #00bb2e;
  border-color: #509c63;
}
.store-detail h6 {
  color: #fff;
  font-weight: 400;
  font-size: 15px !important;
  margin-bottom: 5px;
}
.store-detail p {
  color: #c0c0c0;
  font-weight: 400;
  font-size: 12px !important;
}
.store-detail img {
  border: 1px #4e4e4e solid;
  padding: 2px;
}
.sidenav ul li:hover {
  // background: transparent;
}
.sidenav ul li {
  width: 290px;
  .status-text {
    display: block;
    margin-top: -4px;
    width: 100px;
    color: #818181;
    margin-left: 36px;
  }
}
.modal ul {
  padding: 0px;
}
.modal ul li {
  list-style-type: none;
  text-align: center;
}
.theme-dark .modal ul li p {
  color: #c0c0c0;
}
.modal ul li + li {
  margin-top: 20px;
}
.modal-body .grey-outline-btn {
  border: 1px #808080 solid;
  background-color: transparent !important;
  color: #808080;
  width: 120px;
}
.modal-body .grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.modal-body .grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.modal-body button {
  // padding: 0.475rem 1rem;
  width: 120px;
}
.theme-dark .modal-body .grey-outline-btn {
  border: 1px #606060 solid;
  background-color: transparent !important;
  color: #606060;
  width: 120px;
}
.theme-dark .modal-body .grey-outline-btn:hover {
  background-color: #606060 !important;
  color: #fff;
}
// .fa-sync {
//   transform: rotate(180deg);
//   -webkit-transform: (180deg);
//   transition: 0.5s all ease;
// }
.animate-sync-logo {
  animation: rotation 0.4s infinite linear;
  -webkit-animation: rotation 0.4s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
    -webkit-transform: rotate(359deg);
  }
}
</style>
